import {getDataCurrent} from "./token"

export const getRole = (menuCode: string) => {
    const permissionList = getDataCurrent().role_permissions || []
    let role = permissionList.find((item: any) => item.menu_code === menuCode)
    return role?.permission || {}
}
